module.exports = __webpack_public_path__ + "img/voucherdesign.d33ebe95.svg";